import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { tree } from '@/api/system/department';
import { DEPARTMENT_STATUS } from '@/constant/system/code';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentSelect',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    modelValue: {},
    valueKey: {
      default: 'departmentCode'
    },
    deptDisabled: {
      type: Function,
      default: () => false
    },
    disableChildren: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    collapseTags: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const prop = __props;
    const emit = __emit;
    const selectLoading = ref(false);
    const options = ref([]);
    const selectValue = computed({
      get() {
        return prop.modelValue;
      },
      set(val) {
        emit('update:modelValue', val);
      }
    });
    init();
    function init() {
      if (prop.multiple) {
        selectValue.value = prop.modelValue ? prop.modelValue : [];
      } else {
        selectValue.value = prop.modelValue ? prop.modelValue : null;
      }
      loadTree();
    }
    function handleSelectVisibleChange(visible) {
      if (visible && prop.lazyLoad && options.value.length === 0) {
        refresh();
      }
    }
    function refresh() {
      loadTree();
    }
    function loadTree() {
      if (selectLoading.value) {
        return;
      }
      selectLoading.value = true;
      tree({}).then(result => {
        const treeData = result.data;
        const opt = [];
        if (treeData && treeData.length > 0) {
          for (const dept of treeData) {
            opt.push(buildOption(dept));
          }
        }
        options.value = opt;
      }).finally(() => {
        selectLoading.value = false;
      });
    }
    function buildOption(dept, parentOption) {
      const option = dept2Option(dept);
      if (parentOption && parentOption.disabled && prop.disableChildren) {
        option.disabled = true;
      }
      option.children = [];
      if (dept.children && dept.children.length > 0) {
        for (const child of dept.children) {
          option.children.push(buildOption(child, option));
        }
      }
      return option;
    }
    function dept2Option(dept) {
      const disabled = prop.deptDisabled(dept) || dept.status === DEPARTMENT_STATUS.DISABLED.CODE;
      return {
        value: extractValue(dept),
        label: `${dept.departmentName} - ${dept.departmentCode}`,
        disabled: disabled
      };
    }
    function extractValue(dept) {
      return dept[prop.valueKey];
    }
    return (_ctx, _cache) => {
      const _component_x_tree_select = _resolveComponent("x-tree-select");
      return _openBlock(), _createBlock(_component_x_tree_select, {
        modelValue: _unref(selectValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectValue) ? selectValue.value = $event : null),
        loading: _unref(selectLoading) && _ctx.showLoading,
        flat: _ctx.flat,
        multiple: _ctx.multiple,
        options: _unref(options),
        "collapse-tags": _ctx.collapseTags,
        placeholder: "选择部门",
        "no-options-text": "暂无选项",
        "auto-expand-checked-node": true,
        "include-half-checked-node": false,
        clearable: true,
        onVisibleChange: handleSelectVisibleChange
      }, null, 8, ["modelValue", "loading", "flat", "multiple", "options", "collapse-tags"]);
    };
  }
});